// components/Projects.js
import React from "react";
import { FaGithub } from "react-icons/fa";
import { BiWorld } from "react-icons/bi";
import img1 from "./../Assets/html.png";
import img2 from "./../Assets/css.png";
import img3 from "./../Assets/javascript.png";
import img4 from "./../Assets/plantorder.png";
import img5 from "./../Assets/overstock1.png";
import img6 from "./../Assets/birthday.png";
import img7 from "./../Assets/react.png";
import img8 from "./../Assets/travelapp2.png";
import img9 from "./../Assets/starrating.png";
import img10 from "./../Assets/totoo.png";
import img11 from "./../Assets/youtube.png";
import img12 from "./../Assets/redux.png";
import img13 from "./../Assets/bootstrap.png";
import img14 from "./../Assets/quiz.png";
import img15 from "./../Assets/counter.png";
import img16 from "./../Assets/ecotravel.png";
import img17 from "./../Assets/chakra-ui.png";
import img18 from "./../Assets/googleform.png";
import img19 from "./../Assets/node-js.png";
import img20 from "./../Assets/mongodb.png";
import img21 from "./../Assets/express.png";
import img22 from "./../Assets/todoserver.png";
import img23 from "./../Assets/admin.png";
import img24 from "./../Assets/tailwind.png";
import img25 from "./../Assets/sync.png";
import img26 from "./../Assets/ecore.png";
import img27 from "./../Assets/firebase.png";

const projectsData = [
  {
    title: "Youtube Clone",
    image: img11,
    description:
      "Created a YouTube Clone with core features like commenting, channel subscriptions, google authentication, home page with recommended videos,  categories video, and easily search for content.",
    techStack: [img7, img27, img12, img13, img1, img3],
    aLink: "https://github.com/Swetarani-Patel/mywork/tree/main/youtube/src",
    liveLink: "https://not-874a5.web.app",
  },
  {
    title: "Admin Dashboard",
    image: img23,
    description:
      "Developed a feature-rich React Admin Panel with dynamic data visualization, content management, efficient task tracking, and intuitive drop-down editing for streamlined business operations.",
    techStack: [img7, img3, img25, img24],
    aLink: "https://github.com/Swetarani-Patel/admindashboard/tree/main/src",
    liveLink: "https://dainty-tanuki-b9044c.netlify.app/",
  },
  {
    title: "E-commerce",
    image: img26,
    description:
      "Features dual authentication options,  JWT-based login and signup with password hashing and Firebase for seamless access. Password resets via email OTP, required logins for purchases, with email receipts upon successful transactions.",
    techStack: [img19, img27, img20, img21, img7, img3, img12],
    aLink: "https://github.com/Swetarani-Patel/mywork/tree/main/reactecommerce",
    liveLink: "https://ytube2-8f89d.web.app/",
  },
  // {
  //   title: "To-Do List",
  //   image: img22,
  //   description:
  //     "Created a robust To-Do app for efficient task management, featuring adding, editing, and deleting tasks. Users can filter tasks by status (active or done) and remove completed ones.",
  //   techStack: [img19, img20, img21, img7, img3, img12],
  //   aLink: "https://github.com/Swetarani-Patel/mywork/tree/main/MERN%20STACK",
  //   liveLink: "https://teal-gelato-be4ac5.netlify.app/",
  // },
  // {
  //   title: "Travel and Tour",
  //   image: img8,
  //   description:
  //     "Experience the world like never before with our Travel and Tour Website. Explore, plan, and make unforgettable memories with our Travel and Tour Website.",
  //   techStack: [img7, img2, img3],
  //   aLink: "https://github.com/Swetarani-Patel/mywork/tree/main/travelapp",
  //   liveLink: "https://dynamic-chaja-918910.netlify.app/",
  // },
  // {
  //   title: "SOP Generator",
  //   image: img18,
  //   description:
  //     "Developed an SOP Generator with automatic email notifications, seamlessly delivering user-submitted details to their provided email address.",
  //   techStack: [img19, img20, img21, img7, img3, img2],
  //   aLink:
  //     "https://github.com/Swetarani-Patel/mywork/tree/main/googleform/frontend/src",
  //   liveLink: "https://google-form-bysweta.netlify.app/",
  // },

  // {
  //   title: "Quiz",
  //   image: img14,
  //   description:
  //     "Developed a React-based Online Exam App with features including real-time scoring, dynamic question cards, API integration, a user-friendly interface, instant feedback, and a 'Show Ans' option.",
  //   techStack: [img7, img2, img3],
  //   aLink:
  //     "https://github.com/masai-course/swetarani_patel_pw12_122/tree/master/unit-6/sprint-2/evaluation/1940-1853-rQSIlL/masai-cp-problems-1940-1853-rQSIlL-2b3e12e97c0a695670635ad3bd951655dc56b099/src",
  //   liveLink: "https://glittering-sawine-0a194c.netlify.app/",
  // },

  // {
  //   title: "Plant Order",
  //   image: img4,
  //   description:
  //     "PlantOrder is an online platform for ordering a wide variety of plants. Discover the perfect green companions to enhance your living spaces and create a tranquil environment.",
  //   techStack: [img1, img2, img3],
  //   aLink: "https://github.com/saurabhWakde/-Plant_Order_Application",
  //   liveLink: "https://plant-order-website.vercel.app/",
  // },
  // {
  //   title: "Overstock",
  //   image: img5,
  //   description:
  //     "Overstock is a user-friendly platform for discounted, high-quality furniture with intuitive search and seamless checkout.",
  //   techStack: [img1, img2, img3],
  //   aLink: "https://github.com/RapidKS/OverStock_Project",
  //   liveLink: "https://radiant-nougat-5767ba.netlify.app/index.html",
  // },
  // {
  //   title: "Ecotourism",
  //   image: img16,
  //   description:
  //     "Incorporated into our travel app website are essential features that enable users to sort destinations by both rating and location, conduct seamless searches, and facilitate secure payments, all powered by React.",
  //   techStack: [img7, img17, img3],
  //   aLink:
  //     "https://github.com/slowandrarecooked/ecotourism/tree/main/ecotourismapp/src",
  //   liveLink: "https://luxury-tapioca-dd3a31.netlify.app/",
  // },
  // {
  //   title: "To-Do App",
  //   image: img10,
  //   description:
  //     "Interactive Todo list that updates in real-time with each addition, update, or deletion of a task.",
  //   techStack: [img2, img3, img7],
  //   aLink: "https://github.com/Swetarani-Patel/mywork/tree/main/reactTodo",
  //   liveLink: "https://regal-torte-2020d7.netlify.app/",
  // },
  
  // {
  //   title: "Star Rating App",
  //   image: img9,
  //   description:
  //     " Developed a React ratings app with login/logout, star ratings, and comment management.",
  //   techStack: [img2, img3, img7],
  //   aLink:
  //     "https://github.com/masai-course/swetarani_patel_pw12_122/tree/master/unit-6/sprint-2/day-2/assignments/starratingreact/masai-cp-problems-1947-1724-JXvefw-8ef1a5e88883f535e2c61c80868ca59d203ae78b",
  //   liveLink: "https://startling-smakager-ef6ced.netlify.app/",
  // },
  // {
  //   title: "Input Timer App",
  //   image: img15,
  //   description:
  //     "Developed a React Timer component with flexible initial time input, HH:MM:SS countdown format, and start/stop/reset buttons.",
  //   techStack: [img2, img3, img7],
  //   aLink:
  //     "https://github.com/Swetarani-Patel/mywork/tree/main/reacttimerapp/src",
  //   liveLink: "https://fascinating-alfajores-d2cd40.netlify.app/",
  // },

  // {
  //   title: "Birthday App",
  //   image: img6,
  //   description:
  //     "The Birthday Reminder App helps you stay organized by tracking upcoming birthdays. Never miss a special day with ease.",
  //   techStack: [img2, img3, img7],
  //   aLink: "https://github.com/Swetarani-Patel/mywork/tree/main/birthdayrem",
  //   liveLink: "https://unique-wisp-0f2b9b.netlify.app/",
  // },
];

const Projects = () => {
  return (
    <section className="project-list" id="project">
      <h1 className="subtitle">
        Recent <span>Projects</span>
      </h1>
      <div className="project-container">
        {projectsData.map((project, index) => (
          <div className="project" key={index}>
            <img src={project.image} alt="" />
            <div className="project-detail">
              <div className="heading">
                <h2>{project.title}</h2>
                <div>
                  <a href={project.aLink} target="blank">
                    <i className="bx bxl-github">
                      {" "}
                      <FaGithub />{" "}
                    </i>
                  </a>
                  <a href={project.liveLink} id="live-btn" target="blank">
                    <i className="bx bx-world">
                      {" "}
                      <BiWorld />{" "}
                    </i>
                  </a>
                </div>
              </div>
              <p style={{ fontSize: "0.9rem" }}>
                <span>{project.description}</span>
              </p>
              <div id="tech-stack">
                {project.techStack.map((tech, index) => (
                  <img key={index} src={tech} alt="" />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* <a href="#">See More &gt;&gt;</a> */}
    </section>
  );
};

export default Projects;
